module.exports = __webpack_public_path__ + "img/wechat_total.36bf30f9.png";